export default __webpack_public_path__ + "static/amazon-appstore-badge-english-black-33b08ce80124c4130124d0242f84e4c2.svg";